import {Component, ElementRef, OnInit, ViewChild} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

import {ActivatedRoute} from "@angular/router";
import {CountryService} from "../../../services";
import {Location} from "@angular/common";
import {GiftCardBrand, GiftCardBrandCategory} from "../../../dto/order";
import {GiftCardsService} from "../../../services/gift-cards.service";

@Component({
  selector: 'app-gift-card-brand-edit',
  templateUrl: './gift-card-brand-edit.component.html',
  styleUrls: ['./gift-card-brand-edit.component.css']
})
export class GiftCardBrandEditComponent implements OnInit {

  brand: GiftCardBrand|null;
  giftCardBrandForm: FormGroup;
  brandCategories: GiftCardBrandCategory[];
  isLoading = false;

  constructor(private route: ActivatedRoute,
              private giftCardsService: GiftCardsService,
              private formBuilder: FormBuilder,
              private countryService: CountryService,
              private location: Location
  ) { }
  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');

    this.isLoading = true;
    this.giftCardsService.getBrandCategories().subscribe(data => {
      this.brandCategories = data;

      if (id == null) {
        this.initForm({} as GiftCardBrand);
        this.isLoading = false;
      } else {


          this.giftCardsService.getBrand(parseInt(id)).subscribe(result => {
            this.brand = result;
            this.initForm(result);
            this.isLoading = false;
          });

      }


    });

  }

  initForm(brand: GiftCardBrand) {
    this.giftCardBrandForm = this.formBuilder.group({
      id: brand.id,
      name: brand.name,
      discount: brand.discount,
      userDiscount: brand.userDiscount,
      userIsEnabled: brand.userIsEnabled,
      categoryId: brand.categoryId,
      sortOrder: brand.sortOrder,

    });
  }

  returnBack() {
    this.location.back();
  }

  onSubmit(form: FormGroup) {

    if (form.value.id) {
      this.giftCardsService.updateBrand(form.value)
        .subscribe(() => this.returnBack());
    } else {

    }

  }

}
